import { 
  useState, 
  useEffect,
} 
from 'react'
import { 
  useSelector, 
  useDispatch, 
} from 'react-redux'
import { 
  useNavigate,
} from 'react-router-dom'

import { Helmet } from 'react-helmet-async'

import { 
  loginUser, 
  reset, 
} from "../features/auth/authSlice"

import {
  Input,
  Box,
  Text,
  Link,
} from '@chakra-ui/react'

import Map1Image from '../assets/images/map1-800-600.png'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import PasswordResetRequestView from './page_elements/PasswordResetRequestView'
import PasswordResetFormView from './page_elements/PasswordResetFormView'

import StatusOverlay from '../components/StatusOverlay'
import LoadingOverlay from '../components/LoadingOverlay'
function Login() {

  const [showForgottenPassword, setShownForgottenPassword] = useState(false)

  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues: {
      email: "",
      password: ""
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .email("Invalid email address"),
      password: Yup.string()
        .required("Password is required")
    }),
    onSubmit: (values) => {
      const formData = {
        email: values.email,
        password: values.password
      }
      dispatch(loginUser({ formData }))
    }
  })

  const navigate = useNavigate()

  const { user, isLoading, isError, isSuccess, message } = useSelector(
    (state) => state.auth
  )

  useEffect(() => {

    if (isSuccess || user) {
      navigate('/myjourneys')
    }

    dispatch(reset())
  }, [user, isSuccess, navigate, dispatch])

  if (isLoading) {
    return (
      <>
        <LoadingOverlay type="full" />
      </>
    )
  }

  return (
    <>
      <Helmet>
        <title>Login | TrainLookout</title>
        <meta name="description" content="Login to your TrainLookout" />
        <meta name="keywords" content="login, trainlookout, train, lookout, trainlookout, train lookout, trainlookout.com, trainlookout.com login, trainlookout login, trainlookout.com login page, trainlookout login page" />
        <link rel="canonical" href="/login" />
      </Helmet>

      <PasswordResetFormView />

      {isError && (<StatusOverlay type="top-alert-error" text={`Error: ${message}`} />)}

      { showForgottenPassword && <PasswordResetRequestView />}

      <section className="vh-100" style={{ backgroundColor: '#eee' }}>
        <div className="container h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col-lg-12 col-xl-11">
              <div className="card text-black" style={{ borderRadius: '25px' }}>
                <div className="card-body p-md-5">
                  <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">
                      <p className="text-center h1 fw-bold mb-5 mx-1 mx-md-4 mt-4">Login</p>
                      <form onSubmit={formik.handleSubmit} className="mx-1 mx-md-4">
                        {(formik.errors.email && formik.touched.email) && (<Box>{formik.errors.email}</Box>)}
                        {(formik.errors.password && formik.touched.password) && (<Box>{formik.errors.password}</Box>)}
                        <div className="d-flex flex-row align-items-center mb-4">
                          <i className="fas fa-envelope fa-lg me-3 fa-fw" />
                          <div className="form-outline flex-fill mb-0">
                            <Input
                              type="email"
                              placeholder="Email address"
                              id="email"
                              name="email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mb-4">
                          <i className="fas fa-lock fa-lg me-3 fa-fw" />
                          <div className="form-outline flex-fill mb-0">
                            <Input
                              type="password"
                              placeholder="Password"
                              value={formik.values.password}
                              id="password" name="password"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />

                        <Text
                          fontSize='sm'
                        >
                          Forgot your password?
                          <Link onClick={() => setShownForgottenPassword(true)} color='blue.500'> Click here</Link>
                        </Text>
                          </div>
                        </div>
                        <div className="d-flex justify-content-center mx-4 mb-3 mb-lg-4">
                          <button type="submit" className="btn btn-primary btn-lg">Login</button>
                        </div>
                      </form>
                    </div>
                    <div className="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">
                      <img src={Map1Image} className="img-fluid" alt="Sample image" />
                    </div>
                  </div>
                  <Text>
                    New to TrainLookout?
                    <Link href='/register' color='blue'> Create a free account</Link>
                  </Text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Login